export default __webpack_public_path__ + "static/media/email-new.cf4884f6.svg";